export default __webpack_public_path__ + "static/media/HASSAN_NL_EPILOGFIN2.4f33636b.mp3";